var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ze-contactUs",style:(_vm.customStyles),on:{"click":_vm.openZendesk}},[_vm._v("\n    "+_vm._s(_vm.$t('CONTACT_US_EMAIL'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }